<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'JobsCompany' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to job list</span>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.getdata" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.getdata && datalist.length > 0">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="d-flex">
                      <div class="d-inline">
                        <h2 class="text-md-h4 font-weight-bold">
                          {{ datalist[0].job_name ? datalist[0].job_name : 'Job Title' }}
                        </h2>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                    <v-chip
                      class="mb-0"
                      color="red darken-4"
                      small
                      dark>
                      <v-icon left small>
                        mdi-calendar-range
                      </v-icon>
                      {{ datalist[0].job_valid ? datalist[0].job_valid : 'Today' }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-tabs
                      v-model="tabdata"
                      show-arrows>
                      <v-tabs-slider :color="maincolor"></v-tabs-slider>
                      <v-tab href="#detail" active-class="main-style-slide">
                        Detail
                      </v-tab>
                      <v-tab href="#jobapp" active-class="main-style-slide">
                        <v-badge
                          color="error"
                          :content="datalist[0].jumapp">
                          Job applicant
                        </v-badge>
                      </v-tab>
                      <v-tab href="#jobsave" active-class="main-style-slide" v-if="false">
                        Job save
                      </v-tab>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-tabs-items :touchless="true" v-model="tabdata">
                      <v-tab-item value="detail">
                        <v-card flat>
                          <v-card-text class="px-0">
                            <v-row class="black--text">
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Monthly salary range</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-currency-usd
                                  </v-icon>
                                  {{ datalist[0].job_salary ? datalist[0].job_salary : 1 | rupiahformat }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Job Type</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-account-hard-hat
                                  </v-icon>
                                  {{ datalist[0].job_type ? datalist[0].job_type : 'type' }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Specialization</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  <v-icon :color="maincolor">
                                    mdi-account-details-outline
                                  </v-icon>
                                  {{ datalist[0].job_special ? datalist[0].job_special : 'Specialization' }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Company size</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  {{ datalist[0].com_size ? datalist[0].com_size : '2' }} employees
                                </h3>
                              </v-col>
                              <v-col cols="12" md="4">
                                <span class="text-subtitle-1">Location</span>
                                <h3 class="text-md-h6 font-weight-bold mb-3">
                                  {{ datalist[0].job_location ? datalist[0].job_location : 'Location' }}
                                </h3>
                              </v-col>
                              <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12">
                                <h3 class="text-md-h5 font-weight-bold mb-3">
                                  Job Description
                                </h3>
                                <div
                                  class="content-editor"
                                  v-html="datalist[0].job_desc ? datalist[0].job_desc : 'Description'">
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="jobapp">
                        <v-card flat>
                          <v-card-text class="px-0">
                            <v-row class="black--text">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(appl, i) in applist"
                                :key="i">
                                <applicant :data="appl"></applicant>
                              </v-col>
                            </v-row>
                            <v-row class="black--text text-center">
                              <v-col cols="12" md="12">
                                <infinite-loading :identifier="infiniteId" @infinite="getAppJob">
                                  <div slot="spinner">Loading...</div>
                                  <div slot="no-more"></div>
                                  <div slot="no-results"></div>
                                </infinite-loading>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="jobsave" v-if="false">
                        <v-card flat>
                          <v-card-text class="px-0">
                            <v-row justify="center" class="black--text">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(save, i) in savelist"
                                :key="i">
                                <v-card
                                  class="flex-grow-1"
                                  rounded="lg"
                                  outlined>
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" md="12">
                                        <div class="d-flex">
                                          <div class="d-inline mr-5">
                                            <v-img
                                              :lazy-src="require('../../assets/default.jpg')"
                                              max-height="70"
                                              max-width="70"
                                              :src="save.urlpic ? save.urlpic : ''">
                                            </v-img>
                                          </div>
                                          <div class="d-inline">
                                            <h4 class="text-md-h6 font-weight-bold">
                                              {{ save.user_firstname }} {{ save.user_lastname }}
                                            </h4>
                                            <v-chip
                                              outlined
                                              class="mr-1 mb-1"
                                              color="deep-orange"
                                              small
                                              dark>
                                              {{ save.js_pref_salary | rupiahformat }}
                                            </v-chip>
                                            <v-chip
                                              outlined
                                              class="mr-1 mb-1"
                                              color="primary"
                                              small
                                              dark>
                                              {{ save.js_pref_special }}
                                            </v-chip>
                                          </div>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                  <v-card-actions>
                                    <v-btn
                                      small
                                      text
                                      color="teal accent-4"
                                      @click="showProfile(save)">
                                      Profile
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-col>
                            </v-row>
                            <v-row class="black--text text-center">
                              <v-col cols="12" md="12">
                                <infinite-loading :identifier="infiniteSaveId" @infinite="getSaveJob">
                                  <div slot="spinner">Loading...</div>
                                  <div slot="no-more"></div>
                                  <div slot="no-results"></div>
                                </infinite-loading>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'JobsCompany' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Back to job list</span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import InfiniteLoading from 'vue-infinite-loading';
import Applicant from '../../components/Applicant.vue';

export default {
  name: 'JobdetailCompany',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      apply: false,
      save: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    applist: [],
    savelist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    jobid: '',
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      interview: false,
      profile: false,
    },
    dmodaldata: {
      interview: null,
      profile: null,
    },
    isapply: false,
    issave: false,
    infiniteId: +new Date(),
    paramapp: {
      job_id: '',
      limit: 20,
      offset: 0,
    },
    infiniteSaveId: +new Date(),
    paramsave: {
      job_id: '',
      limit: 20,
      offset: 0,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    if (this.$route.query.jobid && this.$route.query.jobid !== '') {
      this.jobid = this.$route.query.jobid;
      this.getDetailJob();
    }
  },
  watch: {
    '$route.query.jobid'(val) {
      if (val) {
        this.jobid = val;
        this.getDetailJob();
      }
    },
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    closeDmodal(type) {
      if (type === 'interview') {
        this.dmodal.interview = false;
      } else if (type === 'profile') {
        this.dmodal.profile = false;
      } else {
        this.dmodal.interview = false;
      }
    },
    showProfile(item) {
      this.dmodal.profile = true;
      this.dmodaldata.profile = JSON.parse(JSON.stringify(item));
    },
    makeInterview(item) {
      this.dmodal.interview = true;
      this.dmodaldata.interview = JSON.parse(JSON.stringify(item));
    },
    getDetailJob() {
      this.alertdata.show = false;
      this.datalist = [];
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/jobs/detail/' + this.jobid,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                resdata.data.forEach((element) => {
                  this.datalist.push(element);
                });
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid Token!';
      }
    },
    getAppJob($state) {
      if (this.tokenscr && this.datalist.length > 0) {
        this.paramapp.job_id = this.datalist[0].job_id;
        this.axios
          .get(
            this.api + '/api/jobs/apply',
            {
              params: this.paramapp,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramapp.offset += this.paramapp.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                    element.urlresume = this.api + '/upload/resume/' + element.js_resume;
                    this.applist.push(element);
                  });
                  // console.log(this.applist);
                  // this.applist.push(...resdata.data);
                  if (this.applist.length < this.paramapp.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getSaveJob($state) {
      if (this.tokenscr && this.datalist.length > 0) {
        this.paramsave.job_id = this.datalist[0].job_id;
        this.axios
          .get(
            this.api + '/api/jobs/apply',
            {
              params: this.paramsave,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramsave.offset += this.paramsave.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                    this.savelist.push(element);
                  });
                  // this.savelist.push(...resdata.data);
                  if (this.savelist.length < this.paramsave.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    Applicant,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
